"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveDependsOnValuesForLayers = exports.getMatchingLayers = exports.getNewPrintableLayers = void 0;
const designs_1 = require("../../../services/designs");
const either_1 = require("../../../types/either");
const layers_1 = require("../../../services/layers");
const getTemplateSurface_1 = require("../../../services/printables/getTemplateSurface");
const objects_1 = require("../../../helpers/objects");
const strings_1 = require("../../../helpers/strings");
const getNewPrintableLayers = (projectAction, layers, template, printableGroupType) => {
  const designResult = (0, designs_1.findMatchingOrDefaultDesign)({
    newTemplateDesigns: template.designs,
    designId: projectAction.designId,
    printableGroupType
  });
  if (designResult.isLeft()) {
    return (0, either_1.left)(designResult.value);
  }
  const design = designResult.value;
  const newLayersResult = (0, exports.getMatchingLayers)(template.layers, design.layers);
  if (newLayersResult.isLeft()) {
    return (0, either_1.left)(newLayersResult.value);
  }
  const newLayers = newLayersResult.value;
  let mergedLayers = [...newLayers];
  const isCompositeDesign = !!(design.allowedPages !== 'first' && design.coverage && design.coverage === 'partial');
  // this is only for the interior pages of books, when we update from full-spread to partial
  // we need to make the composite design to have the 2 partial in one printable
  if (isCompositeDesign) {
    const surface = (0, getTemplateSurface_1.getTemplateSurface)({
      template,
      printableGroupType
    });
    const shiftedLayers = (0, layers_1.shiftDesignLayersRight)(newLayers, surface);
    mergedLayers = (0, layers_1.makeCompositeDesign)(projectAction.activePage || '', layers, newLayers, shiftedLayers, surface);
  }
  return (0, either_1.right)({
    mergedLayers,
    isCompositeDesign
  });
};
exports.getNewPrintableLayers = getNewPrintableLayers;
const getMatchingLayers = (layers, ids) => {
  if (!ids.length) {
    return (0, either_1.right)([]);
  }
  const matchingLayers = layers.filter(layer => {
    return ids.includes(layer.id);
  });
  if (matchingLayers.length === 0) {
    return (0, either_1.left)(new Error(`Could not find matching layers for ids: ${ids.join()}`));
  }
  return (0, either_1.right)(matchingLayers);
};
exports.getMatchingLayers = getMatchingLayers;
const resolveDependsOnValuesForLayers = (layers, templateAttributes, productOptions) => {
  return layers.map(layer => {
    const {
      dependsOn
    } = layer;
    if (!dependsOn) {
      return layer;
    }
    dependsOn.forEach(dependsOnEntry => {
      const {
        value,
        keyPath
      } = dependsOnEntry;
      // this will handle sourcing value from templateAttributes
      const stringToReplaceMatch = value.match(/\${.*?}/g);
      const stringToReplace = stringToReplaceMatch && stringToReplaceMatch[0]; // '${art.attributes.foil_color:hexCode}' -- includes brackets, this whole thing will be replaced in the end
      const insideBracketsRegex = /(?<=\${)(.*?)(?=})/g;
      const insideBrackets = stringToReplace && stringToReplace.match(insideBracketsRegex);
      const attributeNameAndValueKey = insideBrackets && insideBrackets[0]; // 'art.attributes.foil_color:hexCode' -- no brackets, we parse this to get the data we need 
      if (!attributeNameAndValueKey || !stringToReplace) {
        throw new Error(`Unable to parse dependsOn.value: ${dependsOnEntry.value} for layer: ${layer.id}.`);
      }
      if (value.includes('${art.attributes.')) {
        const valueToPlugIn = sourceTargetAttributeValue(attributeNameAndValueKey, productOptions, templateAttributes);
        if (!valueToPlugIn || typeof valueToPlugIn !== 'string') {
          const errorData = {
            layerId: layer.id,
            dependsOnEntry,
            templateAttributes,
            productOptions
          };
          throw new Error(`Unable to resolve depends-on values for: ${errorData}`);
        }
        const newValue = value.replace(stringToReplace, valueToPlugIn);
        (0, objects_1.setNestedValue)(layer, keyPath, newValue);
      }
    });
    return layer;
  });
};
exports.resolveDependsOnValuesForLayers = resolveDependsOnValuesForLayers;
const sourceTargetAttributeValue = (attributeNameAndValueKey, productOptions, templateAttributes) => {
  const [sourcePath, valueKey] = attributeNameAndValueKey.split(':'); // ['art.attributes.foil_color', 'hexCode']
  const attributeName = (0, strings_1.getAfterSubstring)(sourcePath, 'art.attributes.'); // 'foil_color'
  const sourceAttribute = templateAttributes[attributeName]; // { display: 'swatch', label: 'Foil Color', options: [...], ...}
  const productOptionValue = attributeName && productOptions[attributeName]; // 'gold'
  const sourceAttributeOption = sourceAttribute === null || sourceAttribute === void 0 ? void 0 : sourceAttribute.options.find(option => option.value === productOptionValue); // { value: 'gold', hexCode: '#123123', label: 'Gold' }
  return sourceAttributeOption && sourceAttributeOption[valueKey];
};